const createLineItemId = (orderLineItem)=>{
    /**
   * Using `window.btoa` here as a slightly naive approach to create a hash of
   * the order line item which can be used as an identifier.
   */ try {
        return window.btoa(JSON.stringify({
            sku: orderLineItem.product.sku,
            meta: orderLineItem.__typename === 'OrderLineItemContactLens' && orderLineItem.isSubscription ? orderLineItem.prescription : orderLineItem.lineItemNumber,
            quantity: orderLineItem.quantity
        }));
    } catch (e) {
        console.error(e);
        return `${orderLineItem.product.sku}`;
    }
};

export { createLineItemId };
//# sourceMappingURL=create-line-item-id.js.map
